<template>
  <v-row>
    <v-col cols="12" lg="12">
      <!-- <SumarryReports isActive="activated"></SumarryReports> -->
    </v-col>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  AP List
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <v-btn color="primary" @click="addAP()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add
                </v-btn>
                <!-- <v-btn color="primary" class="ml-2" @click="goBack()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add Serial
                </v-btn> -->
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.brandId`]="{ item }">
            {{ filterBrands(item.brandId)[0].name }}
          </template>

          <template v-slot:[`item.modelId`]="{ item }">
            {{ filterModels(item.modelId)[0].name }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn x-small color="pink" dark @click="editAP(item)"> Edit</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <AddApDialog
      :dialog="addApDialog.dialog"
      :actionType="addApDialog.actionType"
      :data="addApDialog.data"
      @close="addApDialog.dialog = !addApDialog.dialog"
      @response="addApDialogResponse"
    ></AddApDialog>

    <Snackbar></Snackbar>
  </v-row>
</template>

<script>
import moment from "moment";
// import SumarryReports from "./components/dashboard_components/SumarryReports.vue";
import AddApDialog from "../dialogs/management/AddApDialog.vue";
import Snackbar from "../dialogs/Snackbar.vue";

export default {
  name: "ActivatedList",
  components: {
    AddApDialog,
    Snackbar,
  },
  data() {
    return {
      search: "",
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        // name, code, permission,bras, ipPool,cityCode, cpLink, cp, type
        headers: [
          {
            text: "Name",
            value: "name",
          },
          { text: "Code", value: "code" },
          { text: "Permission", value: "permission" },
          {
            text: "BRAS",
            value: "bras",
          },
          { text: "IP Pool", value: "ipPool" },
          { text: "City Code", value: "cityCode" },
          { text: "CP Link", value: "cpLink" },
          { text: "CP", value: "cp" },
          { text: "Type", value: "type" },
          {
            text: "Date/Time Created",
            value: "createdDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
          { text: "Actions", value: "actions" },
        ],
        data: [],
      },

      addApDialog: {
        dialog: false,
        actionType: "ADD",
        data: null,
      },
    };
  },

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/ap-list")
        .then((response) => {
          const newArr = response.data.data.apList;
          // console.log(newArr);
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    addAP() {
      this.addApDialog.actionType = "ADD";
      this.addApDialog.dialog = true;
    },

    editAP(data) {
      // console.log(data)
      this.addApDialog.actionType = "EDIT";
      this.addApDialog.data = data;
      this.addApDialog.dialog = true;
    },

    addApDialogResponse(e) {
      if (e.status) {
        this.getList();
      }

      // this.snachbar.message = e.message;
      this.$store.dispatch("addSnackbarMessage", e.message);
      this.$store.dispatch("addSnackbar", true);
      this.addApDialog.dialog = false;
    },
  },
  created() {
    this.getList();
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
